import React from "react";
// UI Frameworks
import { TableCell } from "@mui/material";
// Common Components
import { Button, Modal } from "src/Components";
// Requests
import { getGoldPositionsOrderTable } from "src/Requests/goldArbitrage";
// Types
import {
  GoldPositionsOrderSearchParams,
  GoldPositionsOrderTableReport,
  TriggeredPositionsTableReport,
} from "src/Interfaces/goldArbitrage";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
// Tables
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";

const AdditionalHeader = (_props: IAdditionalHeaderProps) => {
  return <TableCell />;
};

export const GoldPositionOrderDetails = ({ goldPositionId }: { goldPositionId: number }) => {
  const searchParameters = React.useMemo<GoldPositionsOrderSearchParams>(
    () => ({ goldPositionId }),
    [goldPositionId],
  );

  return (
    <div className="min-w-[600px] max-w-full overflow-x-auto">
      <TableTemplate<GoldPositionsOrderSearchParams, GoldPositionsOrderTableReport>
        TableUI={CommonTableUI}
        getDataTable={getGoldPositionsOrderTable}
        searchParameters={searchParameters}
      />
    </div>
  );
};

const AdditionalCol: React.FC<{
  row: TriggeredPositionsTableReport;
  onAction: () => void;
}> = ({ row }) => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = React.useState(false);

  return (
    <TableCell>
      {isDetailsModalOpen ? (
        <Modal
          UI={<GoldPositionOrderDetails goldPositionId={row.id} />}
          onClose={() => setIsDetailsModalOpen(false)}
        />
      ) : null}
      <div className="w-24">
        <Button
          onClick={() => setIsDetailsModalOpen(true)}
          text="جزئیات"
          variant="contained"
          className="table-btn"
        />
      </div>
    </TableCell>
  );
};

export const Additional: IAdditional<TriggeredPositionsTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
